module.exports = __webpack_public_path__ + "static/img/powered_by_finvasia.74abbea.png";


//////////////////
// WEBPACK FOOTER
// ./static/prism_admin/images/powered_by_finvasia.png
// module id = ugC5
// module chunks = 2